import { Component } from '@angular/core';

@Component({
    selector: 'black-learning-space',
    templateUrl: './learning-space.component.html',
    styleUrl: './learning-space.component.scss',
    standalone: false
})
export class LearningSpaceComponent {

}
